import styles from "../style.module.css";
const Header = () => {
  return <div className={styles.header}>To-Do App</div>;
};

export default Header;
